/**
 * Styled components for AskHumanBox
 */

import styled from 'styled-components';

import { IOcAppTheme, OcColors } from '../../config/ocTheme';

/**
 * Box containing Ask Human prompt and button in transcript footer
 * Always uses medium gray background with dark text for consistency
 */
export const AskHumanBoxContainerInFooter = styled.div`
  z-index: 10;
  max-height: fit-content;
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  padding: 16px;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => (theme as IOcAppTheme).color.secondaryBG || OcColors.bg2};
`;

/**
 * Prompt text for Ask Human ("Need opinions? AI can help you post.")
 */
export const AskHumanPrompt = styled.div`
  font-size: ${({ theme }) => theme.font.size.default};
  color: ${({ theme }) => (theme as IOcAppTheme).color.textSecondary || OcColors.defaultText};
  align-items: center;
  display: flex;
`;

